import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
interface LowRunwayWarningProps {
  cash: number;
  burnRate: number;
}
export function LowRunwayWarning({
  cash,
  burnRate
}: LowRunwayWarningProps) {
  // Only show if burning cash
  if (burnRate <= 0) return null;
  const runway = cash / burnRate;
  // Only show if runway < 2 quarters
  if (runway >= 2) return null;
  const isCritical = runway < 1;
  return <div className={`
      w-full mb-6 p-4 rounded-lg border flex items-start animate-pulse-slow
      ${isCritical ? 'bg-danger/10 border-danger/50 text-danger' : 'bg-secondary/10 border-secondary/50 text-secondary'}
    `} data-id="element-181">
      <AlertTriangleIcon className="w-5 h-5 mr-3 flex-shrink-0 mt-0.5" data-id="element-182" />
      <div data-id="element-183">
        <h3 className="font-bold text-sm uppercase tracking-wider mb-1" data-id="element-184">
          {isCritical ? 'CRITICAL RUNWAY WARNING' : 'LOW RUNWAY ALERT'}
        </h3>
        <p className="text-sm opacity-90" data-id="element-185">
          At current burn rate, you have{' '}
          <span className="font-mono font-bold" data-id="element-186">
            {runway.toFixed(1)} quarters
          </span>{' '}
          of cash remaining.
          {isCritical ? ' Bankruptcy is imminent unless you cut costs or increase revenue immediately.' : ' Consider reducing hiring or increasing prices to extend runway.'}
        </p>
      </div>
    </div>;
}